<div class="pannello" [ngClass]="getClasses()" *ngIf="!href">
  <span class="material-symbols-outlined icon" *ngIf="icon && icon !== ''">
    {{ icon }}
  </span>
  <div>
    <div class="title" *ngIf="title && title !== ''">
      {{ title | translate }}
    </div>
    <div class="content" [innerHTML]="content | translate : values"></div>
  </div>
</div>

<a class="pannello" [ngClass]="type" *ngIf="href" [href]="link" target="_blank">
  <span class="material-symbols-outlined icon" *ngIf="icon && icon !== ''">
    {{ icon }}
  </span>
  <div>
    <div class="title">
      {{ title | translate }}
    </div>
    <div class="content" [innerHTML]="content | translate : values"></div>
  </div>
</a>
